import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { RiderProjection } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class BookingCountService extends BaseGetProvider<RiderProjection> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results[0];
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof RiderProjection {
    return RiderProjection;
  }

  get endpoint(): string {
    return this.endpointService.bookingCount();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    storeId: string,
  ): {
    store_id: string;
  } {
    const params: {
      store_id: string;
    } = {
      store_id: storeId,
    };

    return params;
  }
}
